import type { RefObject } from 'react';
import { useEffect, useState } from 'react';
import { useInterval } from '@elfsight/lib-utils';

type UseAnimationType = {
  ref: RefObject<HTMLDivElement | null>;
  triggered: boolean;
  interval: number;
};

export function useAnimation({ ref, triggered, interval }: UseAnimationType) {
  const [animate, setAnimate] = useState(triggered);

  useEffect(() => {
    const { current: element } = ref;

    if (!element) {
      return;
    }

    const endAnimation = () => setAnimate(false);

    element.addEventListener('animationend', endAnimation);

    return () => {
      if (!element) {
        return;
      }

      element.removeEventListener('animationend', endAnimation);
    };
  }, []);

  useInterval(() => setAnimate(true), animate ? null : interval);

  return animate;
}
